import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAudio: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconAudio"><Path d="M21 1.65601L9 5.25601V15.4714C8.39273 15.1669 7.70001 15 7 15C4.96932 15 3 16.4041 3 18.5C3 20.596 4.96932 22 7 22C9.03068 22 11 20.596 11 18.5V6.74407L19 4.34407V12.4714C18.3927 12.1669 17.7 12 17 12C14.9693 12 13 13.4041 13 15.5C13 17.596 14.9693 19 17 19C19.0307 19 21 17.596 21 15.5V1.65601Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAudio;
